<template>
  <qx-card-form title="客户信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="customerInfo" slot-scope="prop">
        <ChooseCustomer
          :isRadio="true"
          :isInput="true"
          v-model="prop.form.customerInfo"
          :otherSearchData="{ state: 1, status: 2 }"
        >
          <span slot="isInputTip" style="margin-left: 8px">
            <span class="primary cur" @click="toAddCustomer">新增</span>
          </span>
        </ChooseCustomer>
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  customerArchivesList,
} from 'api/archives';
import ChooseCustomer from 'components/choose/customer';
export default {
  components: {
    ChooseCustomer,
  },
  data () {
    return {
      otherFormData: {
        addressSts: -1,
      },
      baseForm: {
        orgIdOptions: [],
        inline: true,
        form: [
          {
            label: '客户名称',
            value: 'customerInfo',
            default: {},
            slot: true,
          },
        ],
        rules: {
          customerInfo: [
            { required: true, message: '请输入客户名称', trigger: 'submit' },
            {
              validator: (rule, value, callback) => this.checkObjEmpty(rule, value, callback, '请输入客户名称'),
              trigger: 'submit',
            },
          ],
        },
      },
    };
  },
  methods: {
    async getCustomerId (customerId) {
      let customerInfo = {};
      if (customerId) {
        const res = await customerArchivesList({
          page: 1,
          state: -1,
          customerCode: '',
          customerId,
        });
        if (!res.failed) {
          if (res && res.items && res.items.length) {
            if (res.items[0] && res.items[0].customerId && res.items[0].customerId === customerId) {
              customerInfo = res.items[0];
            }
          }
        }
      }
      return customerInfo;
    },

    // 跳转到客户档案新增
    toAddCustomer () {
      this.jump({
        label: '新增客户',
        url: `/manage/archives/customer/archives/edit?id=&fromPage=addressArchives&fromPageLabel=${encodeURIComponent('新增地址档案')}`,
        full: true,
      });
    },

    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      let formData = await this.handleSubData();
      if (formData) {
        if (!this.$route.query.id) {
          // 新增不需要上传这个参数
          delete formData.addressSts;
        }
        delete formData.customerInfo;
        if (!formData.customerId) {
          this.$message.error('当前客户不存在，请点击新增前往客户档案新增客户');
          formData = null;
        }
      }
      return formData;
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        if (formData.customerInfo) {
          formData.customerName = formData.customerInfo.customerName;
          formData.customerId = formData.customerInfo.customerId;
        }
        formData = {
          ...formData,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async init (data = {}) {
      // 如果有 customerId，应该是新增完客户档案返回来的，自动填入
      if (sessionStorage.getItem('customerId')) {
        const customerId = sessionStorage.getItem('customerId');
        // 马上清空，这样下次就不会重复获取
        sessionStorage.removeItem('customerId');
        const customerInfo = await this.getCustomerId(customerId);
        data.customerInfo = {
          customerName: customerInfo.customerName || '',
          customerId: customerInfo.customerId || '',
        };
      }
      // 如果没有定义，补充定义一下
      if (!data.customerInfo) {
        data.customerInfo = {};
      }
      // 如果有缓存数据，使用缓存的数据替换
      if (data.customerId) {
        data.customerInfo.customerId = data.customerId;
      }
      if (data.customerName) {
        data.customerInfo.customerName = data.customerName;
      }
      this.$refs.baseForm.setVal(data);
      this.setFormVal(this.otherFormData, data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
